import { defineElement } from '~/utils/gw-utils';

class ModalOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(this.button);
    });
  }
}

defineElement('modal-opener', ModalOpener);
